'use client';

import React from 'react';
import InitialsFacet from './InitialsFacet'; // Adjust path as needed
import FacetGroup from './FacetGroup'; // Adjust path as needed
import { FacetSortCriterion } from '@coveo/headless';

type InitialsAndFacetsProps = {
  initialFacetField: string;
  initialFacetLabel?: string;
  facetGroupProps: {
    fields: string[];
    labels?: Record<string, string>;
    numberOfValues?: number;
    sortCriteria?: FacetSortCriterion;
  };
};

const InitialsAndFacets = ({
  initialFacetField,
  initialFacetLabel,
  facetGroupProps,
}: InitialsAndFacetsProps): JSX.Element => {
  return (
    <div className="initials-and-facets-wrapper">
      {/* Initials Facet at the top */}
      <div className="border-b-2 border-gray-50">
        <InitialsFacet field={initialFacetField} label={initialFacetLabel} />
      </div>
      {/* Facet Group below - Always Accordion Mode */}
      <FacetGroup {...facetGroupProps} forceAccordionOnDesktop={true} hideHeader={true} />
    </div>
  );
};

export default InitialsAndFacets;
